import 'rxjs/add/operator/switchMap'
import 'rxjs/add/operator/mergeMap'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/observable/of'
import 'rxjs/add/observable/from'
import X2JS from 'x2js'
import { ServiceTypes } from './serviceRedux'
import { NotificationTypes } from './notificationRedux'
import ServiceActions from './serviceRedux'
import { getCapabilitiesUrl } from '../config/services'

const x2js = new X2JS()

const SERVICE_UPDATE_REQUESTED = ServiceTypes.SERVICE_UPDATE_REQUESTED
const SERVICE_UPDATE_FULFILLED = ServiceTypes.SERVICE_UPDATE_FULFILLE
const SERVICE_CARD_MOUNTED = ServiceTypes.SERVICE_CARD_MOUNTED
// const SERVICE_CARD_MOUNTED = NotificationTypes.SERVICE_CARD_MOUNTED
// const SERVICE_UPDATE_FAILED = ServiceTypes.SERVICE_UPDATE_FAILED

const serviceUpdateFulfilled = service => ({
  type: SERVICE_UPDATE_FULFILLED,
  service
})

export const updateServiceEpic = (action$, store) =>
  action$
    .ofType(SERVICE_UPDATE_REQUESTED)
    .switchMap(({ service }) =>
      Observable.from(
        fetch(getCapabilitiesUrl(service, store.getState().login.idToken))
      )
    )
    .mergeMap(response => response.text())
    .map(text => serviceUpdateFulfilled(x2js.xml2js(text)))

export const serviceCardMountedEpic = (action$, store) =>
  action$
  .ofType(SERVICE_CARD_MOUNTED)
  .map(() => {
    const state = store.getState()
    const service = state.serviceCard

    if (!service.name) {
      return { type: 'EMPTY' }
    }
    return ServiceActions.serviceCardChanged(service)
  })



// WEBPACK FOOTER //
// ./src/redux/serviceEpic.js